import { useI18n } from '../i18n';
import { Seo } from '../components/Seo';
import { Button } from '../components/Button';

/**
 * The 404.
 *
 * The Worker returns 200 with the app shell for any unmatched path, because it
 * has no route table of its own (see apps/worker/src/app.ts). This page is what
 * makes that honest: `noindex` keeps mistyped URLs out of search results.
 */
export default function NotFoundPage() {
  const { t, localePath } = useI18n();

  return (
    <>
      <Seo
        title={`${t.notFound.title} — Rickey`}
        description={t.notFound.body}
        path="/404"
        noindex
      />
      <div className="container" style={{ padding: '120px 0 160px', maxWidth: 560 }}>
        <h1 style={{ fontSize: 'clamp(34px, 5vw, 52px)', marginBottom: 16 }}>{t.notFound.title}</h1>
        <p style={{ fontSize: 17, lineHeight: 1.6, color: 'var(--body)', marginBottom: 32 }}>
          {t.notFound.body}
        </p>
        <Button to={localePath('/')} variant="primary" size="lg">
          {t.notFound.cta}
        </Button>
      </div>
    </>
  );
}
